import { useState as c, useCallback as f } from "react";
import { useEffectOnce as l } from "./useEffectOnce.js";
function d(t, o) {
  const [r, u] = c(""), n = f(
    (e, i) => {
      u(e);
      const m = e.split(" ").length + 1, s = i.split(" ").slice(0, m).join(" ");
      if (s === e) return;
      const a = setTimeout(
        () => n(s, i),
        // get a random number between 10ms and 50ms to simulate a random delay
        Math.floor(Math.random() * 40) + 10
      );
      return () => clearTimeout(a);
    },
    []
  );
  return l(() => {
    if (t && o)
      return n("", t);
  }), o ? r : t;
}
export {
  d as useSimulateStream
};
